import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalComponent, SdvorButtonComponent, SdvorSpinnerComponent } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { SdvorNoPaymentsComponent } from './no-payments/no-payments.component';
import { SdvorAddPaymentComponent } from './payment-list/add-payment/add-payment.component';
import { SdvorPaymentListComponent } from './payment-list/payment-list.component';
import { SdvorPaymentComponent } from './payment-list/payment/payment.component';
import { SdvorRemovePaymentModalComponent } from './remove-payment-modal/remove-payment-modal.component';

@NgModule({
  imports: [NgIf, AsyncPipe, SdvorButtonComponent, SdvorSpinnerComponent, IconModule, ModalComponent],
  declarations: [
    SdvorNoPaymentsComponent,
    SdvorPaymentListComponent,
    SdvorPaymentComponent,
    SdvorAddPaymentComponent,
    SdvorRemovePaymentModalComponent,
  ],
  exports: [SdvorPaymentListComponent, SdvorNoPaymentsComponent],
})
export class SdvorPaymentsModule {}
